import React, { Suspense, lazy, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { portalApi } from "@/portal/portalApi";

const App = lazy(() => import("@/App"));
const Landing = lazy(() => import("@/portal/Landing"));
const OltaAdmin = lazy(() => import("@/portal/OltaAdmin"));
const LegalPage = lazy(() => import("@/portal/LegalPage"));
const ALT = /^\/(login|projekte|kunden|stammdaten|einkauf|einstellungen|handbuch)(\/|$)/;

function head({ title, robots, icon }) {
  document.title = title;
  let m = document.querySelector('meta[name="robots"]');
  if (!m) { m = document.createElement("meta"); m.name = "robots"; document.head.appendChild(m); }
  m.content = robots;
  if (icon) document.querySelector('link[rel="icon"]')?.setAttribute("href", icon);
}

function WsGate({ children }) {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    portalApi.get("/portal/status", { params: { ws: "emundts" } })
      .then((r) => (r.data.ok ? setOk(true) : window.location.replace("/?ws=emundts")))
      .catch(() => window.location.replace("/?ws=emundts"));
  }, []);
  return ok ? children : <div className="p-10 text-muted-foreground" data-testid="ws-gate-loading">Laden…</div>;
}

const path = window.location.pathname;
let view;
if (ALT.test(path)) {
  window.location.replace(`/emundts${path}${window.location.search}`);
} else if (path === "/emundts" || path.startsWith("/emundts/")) {
  head({ title: "Emundts App", robots: "noindex, nofollow", icon: "/favicon.png" });
  view = /^\/emundts\/(einladung|passwort-zuruecksetzen|sso)(\/|$)/.test(path) ? <App /> : <WsGate><App /></WsGate>;
} else if (path.startsWith("/olta")) {
  head({ title: "OLTA KI · Verwaltung", robots: "noindex, nofollow", icon: "/favicon-olta.svg" });
  view = <OltaAdmin />;
} else if (path === "/impressum" || path === "/datenschutz") {
  const doc = path.slice(1);
  head({ title: `${doc === "impressum" ? "Impressum" : "Datenschutz"} · OLTA KI`, robots: "index, follow", icon: "/favicon-olta.svg" });
  view = <LegalPage doc={doc} />;
} else {
  head({ title: "OLTA KI", robots: "index, follow", icon: "/favicon-olta.svg" });
  view = <Landing />;
}

if (view) {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode><Suspense fallback={null}>{view}</Suspense></React.StrictMode>,
  );
}
